import { r as registerInstance, h, H as Host, g as getElement } from './index-61528ac5.js';
import { v as version } from './package-27c9b485.js';
import { H as HEADING_LEVELS } from './heading-levels-5b7b4349.js';
import { c as checkOneOf } from './check-one-of-6b3ef8eb.js';

const postAccordionCss = ":host{display:block}";
const PostAccordionStyle0 = postAccordionCss;

const PostAccordion = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.expandedItems = new Set();
        this.headingLevel = undefined;
        this.multiple = false;
    }
    validateHeadingLevel(newValue = this.headingLevel) {
        if (!newValue)
            return;
        checkOneOf(newValue, HEADING_LEVELS, 'The `heading-level` property of the `post-accordion` must be a number between 1 and 6.');
        this.accordionItems.forEach(item => {
            item.setAttribute('heading-level', String(newValue));
        });
    }
    componentWillLoad() {
        this.registerAccordionItems();
        this.validateHeadingLevel();
    }
    collapseToggleHandler(event) {
        event.stopPropagation();
        const toggledItem = event.target;
        const closestParentAccordion = toggledItem.closest('post-accordion');
        if (closestParentAccordion === this.host && toggledItem.localName === 'post-accordion-item') {
            const toggledAccordionItem = event.target;
            const isClosing = this.expandedItems.has(toggledAccordionItem);
            if (isClosing) {
                this.expandedItems.delete(toggledAccordionItem);
            }
            else {
                this.expandedItems.add(toggledAccordionItem);
            }
            if (this.multiple || isClosing)
                return;
            // close other open accordion items to have only one opened at a time
            Array.from(this.expandedItems.values())
                .filter(item => item !== toggledAccordionItem)
                .forEach(item => {
                item.toggle(false);
            });
        }
    }
    /**
     * Toggles the `post-accordion-item` with the given id.
     */
    async toggle(id) {
        const itemToToggle = this.accordionItems.find(item => item.id === id);
        if (!itemToToggle)
            throw new Error(`No post-accordion-item found with id #${id}.`);
        await itemToToggle.toggle();
    }
    /**
     * Expands all `post-accordion-item`.
     *
     * If `multiple="true"` is not set and all items are closed, it will open the first one.
     * Otherwise, it will keep the opened one.
     */
    async expandAll() {
        if (this.multiple) {
            await Promise.all(this.accordionItems.map(item => item.toggle(true)));
        }
        else if (!this.expandedItems.size) {
            await this.accordionItems[0].toggle(true);
        }
    }
    /**
     * Collapses all `post-accordion-item`.
     */
    async collapseAll() {
        await Promise.all(this.accordionItems.map(item => item.toggle(false)));
    }
    registerAccordionItems() {
        this.accordionItems = Array.from(this.host.querySelectorAll('post-accordion-item'));
        this.accordionItems
            .filter(item => {
            return !item.collapsed || this.expandedItems.has(item);
        })
            .forEach((item, index) => {
            if (!this.multiple && index !== 0) {
                item.setAttribute('collapsed', '');
                return;
            }
            this.expandedItems.add(item);
        });
    }
    render() {
        return (h(Host, { key: 'cfc6280e052937f50bc481fe73cf25ede6e40314', "data-version": version }, h("div", { key: '090539a2ebe9d216609a7e56597c5f379d439fb8', class: "accordion" }, h("slot", { key: '4ae4095b14b6b9233f1d66c8543d625a77a77e09', onSlotchange: () => this.registerAccordionItems() }))));
    }
    get host() { return getElement(this); }
    static get watchers() { return {
        "headingLevel": ["validateHeadingLevel"]
    }; }
};
PostAccordion.style = PostAccordionStyle0;

export { PostAccordion as P };
